var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { skipToken } from "@reduxjs/toolkit/query";
import { signupApi } from "apis/eduidSignup";
import { InternalCaptcha } from "components/Common/Captcha";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { clearNotifications } from "slices/Notifications";
import { signupSlice } from "slices/Signup";
import { ServiceInfo } from "./SignupInfo";
import { SignupStepIndicator } from "./SignupStepIndicator";
export function SignupCaptcha() {
    const captchaCompleted = useAppSelector((state) => { var _a; return (_a = state.signup.state) === null || _a === void 0 ? void 0 : _a.captcha.completed; });
    const dispatch = useAppDispatch();
    const [getCaptchaRequest] = signupApi.useLazyGetSignupCaptchaRequestQuery();
    useEffect(() => {
        if (captchaCompleted) {
            dispatch(signupSlice.actions.setNextPage("SIGNUP_TOU"));
        }
    }, [captchaCompleted, dispatch]);
    function getCaptcha() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield getCaptchaRequest();
            if (response.isSuccess) {
                return response.data.payload;
            }
        });
    }
    function handleCaptchaCancel() {
        dispatch(signupSlice.actions.setNextPage("SIGNUP_ENTRY"));
    }
    function handleCaptchaCompleted(response) {
        if (!response)
            return;
        dispatch(signupSlice.actions.setCaptchaResponse({ internal_response: response }));
        dispatch(signupSlice.actions.setNextPage("PROCESS_CAPTCHA"));
    }
    const args = { handleCaptchaCancel, handleCaptchaCompleted };
    // If the user has already completed the captcha, don't show it again
    if (captchaCompleted) {
        return null;
    }
    return (_jsxs("div", { className: "step-container", children: [_jsxs("section", { className: "intro", children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "common.createEduidConfirm", defaultMessage: "Create eduID: Confirm/Accept", description: "Signup" }) }), _jsx(ServiceInfo, {}), _jsx("div", { className: "lead", children: _jsx("p", { children: _jsx(FormattedMessage, { id: "common.captchaLead", defaultMessage: "Confirm that you are a human as protection against automated spam.", description: "Signup captcha lead text" }) }) })] }), _jsx(InternalCaptcha, Object.assign({}, args, { getCaptcha: getCaptcha })), _jsx(SignupStepIndicator, { currentStep: 2 })] }));
}
export function ProcessCaptcha() {
    const captcha = useAppSelector((state) => state.signup.captcha);
    const dispatch = useAppDispatch();
    const { isSuccess, isError } = signupApi.useSendSignupCaptchaResponseQuery(captcha !== null && captcha !== void 0 ? captcha : skipToken);
    useEffect(() => {
        if (captcha) {
            if (isSuccess) {
                dispatch(clearNotifications());
                dispatch(signupSlice.actions.setNextPage("SIGNUP_TOU"));
            }
            else if (isError) {
                dispatch(signupSlice.actions.setNextPage("SIGNUP_CAPTCHA"));
            }
        }
    }, [captcha, isSuccess, isError, dispatch]);
    // Show a blank screen while we wait for a captcha response from the backend
    return null;
}
